import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import { FeedBackPage, TextLabel } from "features/shared/components";
import { useTranslations } from "adapters/i18n";

const styles = {
  container: {
    minHeight: "60vh",
  },
  textLabel: {
    paddingTop: 10,
    width: "323px",
    height: "44px",
    margin: "33.8px 0 0",
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: 1.38,
    textAlign: "center",
    color: "#999",
  },
};

const IngredientRegisterNotFound = ({ classes, text }) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      direction="column"
      justify="center"
      className={classes.container}
    >
      <FeedBackPage>
        <Grid container direction="column" alignItems="center">
          <img
            src="../images/fechamentoTelaVazia.png"
            alt="Lupa de tela vazia"
          />
          <div></div>
          <TextLabel
            id="labelFechamentoFeedBack"
            block
            color="default2"
            className={classes.textLabel}
          >
            {t(text)}
          </TextLabel>
        </Grid>
      </FeedBackPage>
    </Grid>
  );
};

export default withStyles(styles)(IngredientRegisterNotFound);
